import React from "react";
import { Container, Grid, Box } from "@mui/material";
import CourseHeader from "./CourseHeader";
import CourseCurriculum from "./curriculumData";
import InstructorDetails from "./InstructorDetails";

const CourseCurriculumDetails = ({ curriculumData, title, fees, batch }) => {
    return (
        <Box
        sx={{
          background: "#E3F2FD",
        }}
      >
        <Container sx={{ mt: 5 }}>
            <Grid container spacing={3}>
                {/* Left Side (Main Content) */}
                <Grid item xs={12} md={8}>
                    <CourseCurriculum curriculumData={curriculumData} title={title} />
                    <InstructorDetails />
                </Grid>

                {/* Right Side (Price + Enroll) */}
                <Grid item xs={12} md={4}>
                    <CourseHeader title={title} fees={fees} batch={batch} />
                </Grid>
            </Grid>
        </Container>
        </Box>
    );
};

export default CourseCurriculumDetails;
